<template>
  <h2 class="pb-2 border-bottom">Hormone Replacement Therapy (HRT)</h2>
  <p>Personalized Care for Balance and Vitality</p>
  <p>At Diverse Care Now, we provide safe, medically supervised hormone therapies for men and women. Our goal is to restore balance, support energy, and improve overall wellness through personalized treatment plans.”</p>
  <h3>Categories</h3>
  <ul>
    <li>For Women: estrogen & progesterone therapy, bioidentical hormones, thyroid support.</li>
    <li>For Men: testosterone replacement (TRT), thyroid optimization, adrenal support.</li>
    <li>For Both: peptide therapies for vitality, adrenal and cortisol support for stress management.</li>
  </ul>
  <h3>Delivery Options</h3>
  <ul>
    <li>Injections (weekly or biweekly)</li>
    <li>Pellets (long-lasting hormone release for 3–6 months)</li>
    <li>Creams/gels (easy daily use)</li>
    <li>Oral medications (less common, used when safe)</li>
  </ul>
  <h3>Monitoring & Safety</h3>
  <ul>
    <li>Comprehensive lab tests (hormone levels, thyroid, metabolic markers)</li>
    <li>Initial consultation & treatment planning</li>
    <li>Ongoing monitoring & dose adjustments</li>
    <li>Telemedicine follow-ups</li>
  </ul>
  <p>Hormone therapy is not one-size-fits-all — we tailor every plan to your unique needs, always under medical supervision.</p>
</template>

<script>
export default {
  name: 'HormoneReplacementContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
